module.exports = __webpack_public_path__ + "img/34.5b56f6d6.jpg";